module.exports = __webpack_public_path__ + "img/33_27.f7de5e9d.png";